<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row class="no-gutters align-center">

      <v-col cols="12" sm="12" md="4" lg="2" :md="$canRoute('transaction-history') !== 1 ? 8 : 4" :lg="$canRoute('transaction-history') !== 1 ? 3 : 2">
        <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
          single-line solo hide-details>
        </v-text-field>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3">
        <v-select solo :items="allMethods()" v-model="methodName" @input="methodFilter" append-icon="mdi-chevron-down"
          label="Payment methods" class="custom-select" item-text="method_name" item-value="pretty_name">
        </v-select>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3">
        <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="selectedDatesText" placeholder="Date filter" prepend-icon="mdi-calendar"
              append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo
              class="custom-select"></v-text-field>
          </template>
          <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="cancelSelection">
              Cancel
            </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="confirmSelection">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>

      <v-col cols="12" sm="4" md="4" lg="2" align="middle">
        <v-card :color="$vuetify.theme.dark ? 'transparent' : '#f2f7fb'" flat tile>
          <div class="mt-6 custom-checkbox-wrapper">
            <input v-model="testData" class="custom-checkbox-acc" type="checkbox" @change="fetchData" />
            <span class="ml-1 text--ash">Testing A/C</span>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="4" md="4" lg="1" align="middle">
        <ul class="justify-center">
          <li class="text-center">
            <span class="">Total Count:</span>
            <span>{{ formattedAllNumber(pagination.total) }}</span>
          </li>
        </ul>
      </v-col>

      <v-col cols="12" sm="4" md="4" lg="1" v-if="$canRoute('transaction-history') === 1" align="middle">
        <v-btn @click.prevent="downloadCSVexcel" :loading="excelLoading" :disabled="excelLoading" tile elevation="0"  class="mt-6 text-capitalize btn-account mb-0 mx-0"
          color="greenMain">
          <v-icon small>mdi mdi-tray-arrow-down</v-icon>CSV
        </v-btn>
      </v-col>

    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable depositTableForTransaction"
            :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="summaries" :server-items-length="pagination?.total || 10"
              :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.account_fullname="{ item }" v-if="$canRoute('registered-user?tab=1') === 1">
                <router-link class="text-capitalize text--ash" :to="`/registered-user-details/${item?.client_account_id}`">
                  {{ `${item.account_fullname} (${item?.client_account_id})` }}
                </router-link>
              </template>
              <template v-slot:item.account_fullname="{ item }" v-else>
                <span class="text-capitalize text--ash">
                  {{ `${item.account_fullname} (${item?.client_account_id})` }}
                </span>
              </template>
              <template v-slot:item.trx_type="{ item }">
                <div class="d-flex align-items-center">
                  <v-icon color="#B4C2D1" small :class="verifyIcon(item.trx_type)"></v-icon>
                  <span>{{ item.trx_type }}</span>
                </div>
              </template>
              <template v-slot:item.trading_account_no="{ item }">
                {{ item?.trading_account_no }}
              </template>
              <template v-slot:item.account_email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.account_email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                        {{ copiedStates[item.id] ? "mdi mdi-check" : "mdi-content-copy" }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item?.account_email }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.reference="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyReference(item)" style="text-transform: none">
                      {{ item.reference.toString().slice(0, 5) + ".." || "N/A" }}
                      <v-icon x-small class="ml-1" :color="copiedRefStates[item.id] ? 'green' : ''">
                        {{ copiedRefStates[item.id] ? "mdi mdi-check" : "mdi-content-copy" }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item?.reference }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ formatMySQLDate(item?.created_at) }}
              </template>
              <template v-slot:item.payment_system="{ item }">
                {{ item?.payment_system?.method_name || "N/A" }}
              </template>
              <template v-slot:item.amount="{ item }">
                {{ formattedAllNumber(item.amount) }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRANSACTIONS__ACTIONS } from "@/store/action-types";
import { formatNumber } from "@/_helpers/formatNumber";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import router from "@/router";
import toast from "@/services/Notification";
import { formatMySQLDate } from "@/_helpers/formateDate";

export default {
  name: 'TransactionList',

  data() {
    return {
      excelLoading: false,
      testData: false,
      search: "",
      date: null,
      searchTimeout: null,
      selectedDates: [],
      selectedDatesText: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      // OLD
      modal: false,
      dialog: false,
      headers: [
        { text: "Trx Type", align: "start", value: "trx_type" },
        { text: "Date and Time", value: "created_at" },
        { text: "Name", value: "account_fullname" },
        { text: "Email", value: "account_email" },
        { text: "Acc no.", value: "trading_account_no" },
        { text: "Remarks", value: "remarks" },
        { text: "Payment Method", value: "payment_system" },
        { text: "Amount", value: "amount" },
      ],
      copiedStates: {},
      copiedRefStates: {},
      methodName: null,
    };
  },

  computed: {
    ...mapState("trxsummaries", [
      "summaries",
      "summariesExcel",
      "isLoading",
      "paymentMethods",
      "pagination",
    "range"
    ]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    formatMySQLDate,
    ...mapActions("trxsummaries", [
      TRANSACTIONS__ACTIONS.TRXSUMMARIES,
      TRANSACTIONS__ACTIONS.TRXSUMMARIESEXCEL,
    ]),

    allMethods() {
      return [{ id: "All", method_name: "All" }, ...this.paymentMethods];
    },

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    verifyIcon(trx_type) {
      const lowerType = trx_type.toLowerCase();
      if (lowerType.startsWith("d")) return "mdi mdi-tray-arrow-down mr-1";
      if (lowerType.startsWith("w")) return "mdi mdi-tray-arrow-up mr-1";
      return "mdi mdi-repeat mr-1";
    },

    obfuscateAnyEmail(email) {
      return obfuscateEmail(email);
    },

    copyText(item) {
      navigator.clipboard.writeText(item?.account_email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },

    copyReference(item) {
      navigator.clipboard.writeText(item?.reference);
      this.$set(this.copiedRefStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedRefStates, item.id, false);
      }, 1000);
    },

    async fetchData() {
      const params = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
        testData: this.testData,
        method_name: this.methodName === "All" ? null : this.methodName
      };

      if (this.selectedDates?.length === 2) {
        params.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
      }

      await this[TRANSACTIONS__ACTIONS.TRXSUMMARIES](params);
    },

    async downloadCSVexcel(){
      this.excelLoading = true;
      try {
        const params = {
          search: this.search,
          testData: this.testData,
          method_name: this.methodName === "All" ? null : this.methodName
        };

        if (this.selectedDates?.length === 2) {
          params.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
        }
        await this[TRANSACTIONS__ACTIONS.TRXSUMMARIESEXCEL](params);
        this.downloadCSV();
      } catch (error) {
        console.error("Error downloading CSV:", error);
        toast.error("Failed to download CSV file.");
      }finally {
        this.excelLoading = false;
      }
    },

    downloadCSV() {
      const headers = [
        'Trx. Type',
        'Date & Time',
        'Name',
        'Email',
        'Payment Method',
        'Account From',
        'Account To',
        'Amount',
        'Trx. Fee',
        'Net Amount',
        'Comment',
        'Status'
      ];

      const csvData = this.summariesExcel.map(data => {
        const date = new Date(data.created_at);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
        
        const statusMap = {
          0: 'Pending',
          1: 'Approved',
          2: 'Rejected'
        };

        return [
          data.trx_type || '',
          formattedDate,
          data.account_fullname,
          data.account_email || '',
          data.payment_system?.method_name || 'N/A',
          data.from_account || 'N/A',
          data.trading_account_no || '',
          data.amount || 0,
          data.trx_fee || 0,
          data.net_amount || 0,
          data.remarks || 'N/A',
          statusMap[data.status] || ''
        ];
      });

      // Combine headers and data, escaping quotes and commas
      const escapeCSV = (value) => {
        const str = value != null ? value.toString() : '';
        return `"${str.replace(/"/g, '""')}"`; // Escape quotes
      };

      const csvContent = [
        headers.map(escapeCSV),
        ...csvData.map(row => row.map(escapeCSV))
      ].map(row => row.join(',')).join('\n');

      // Create blob and download link
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', `Trx-history-${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },


    async download() {
      const data = {
        date: this.selectedDates,
        method_name: this.methodName
      };
      
    },

    async handleSearch(value) {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },

    methodFilter() {
      this.options.page = 1;
      this.fetchData();
    },

    getCurrentDate() {
      return new Date().toISOString().split("T")[0];
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.options.page = 1;
      this.fetchData();
    },

  },

  watch: {
    range: {
      immediate: true,
      handler(r) {
        if (!r?.start || !r?.end) return;

        // prevent overriding manual selection
        if (this.selectedDatesText) return;

        this.selectedDates = [r.start, r.end];
        this.selectedDatesText = `${r.start} ~ ${r.end}`;
      }
    }
  },


  async created() {
    await this.fetchData();
  },

};
</script>

<style>
.custom-checkbox-wrapper input[type="checkbox"].custom-checkbox-acc {
  appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #ccccccb9;
  border-radius: 4px;
  background-color: transparent;
  position: relative;
  cursor: pointer;
  vertical-align: middle;
  margin-right: 6px;
  transition: all 0.2s ease;
}

.custom-checkbox-wrapper input[type="checkbox"].custom-checkbox-acc:checked {
  border-color: #0e8f6fe0;

}

.custom-checkbox-wrapper input[type="checkbox"].custom-checkbox-acc:checked::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 4px;
  height: 9px;
  border: solid rgb(168, 168, 168);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

</style>